import { t, translateChrome, chromeIdForLabel } from './index'

/**
 * Fixed UI chrome from en.json / ta.json.
 * Always marks output notranslate so leftover browser translators cannot rewrite it.
 * Unmapped English still renders (safe fallback) but stays locked from auto-translate.
 */
const Chrome = ({ id, text, vars, className = '' }) => {
  const resolvedId = id || chromeIdForLabel(text)
  const fromDict = resolvedId ? t(resolvedId, vars) : translateChrome(text)
  const fixed = fromDict != null ? fromDict : text
  if (fixed == null || fixed === '') return null
  return (
    <span className={`notranslate ${className}`.trim()} translate="no">
      {fixed}
    </span>
  )
}

export default Chrome
